module.exports = __webpack_public_path__ + "img/customers.fa53456a.svg";